import { apiClient } from './client';
import type { ContestView, PrizeTier, SweepstakesContest, SweepstakesWinner } from './sweepstakes';

// ============================================================================
// Types
// ============================================================================

export interface CreateMintRewardsInput {
  launchId: string;
  name: string;
  description?: string;
  startsAt: string;
  endsAt: string;
  prizeTiers: Array<{
    name: string;
    description: string;
    type: 'leaderboard' | 'raffle';
    winnerCount: number;
  }>;
}

// ============================================================================
// API Functions
// ============================================================================

export const mintRewardsApi = {
  // Public endpoint (via sweepstakes routes)
  getForLaunch: (launchId: string) =>
    apiClient.get<ContestView | { contest: null }>(`/sweepstakes/launch/${launchId}`),

  // Management endpoints
  getForLaunchManage: (launchId: string) =>
    apiClient.get<(ContestView | { contest: null }) & { pastContests?: ContestView[] }>(`/manage/mint-rewards/launch/${launchId}`),

  create: (data: CreateMintRewardsInput) =>
    apiClient.post<{ contest: SweepstakesContest; prizeTiers: PrizeTier[] }>('/manage/mint-rewards', data),

  update: (id: string, data: Partial<Omit<CreateMintRewardsInput, 'launchId'>>) =>
    apiClient.put<{ contest: SweepstakesContest; prizeTiers: PrizeTier[] }>(`/manage/mint-rewards/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/manage/mint-rewards/${id}`),

  publish: (id: string) =>
    apiClient.post<{ contest: SweepstakesContest }>(`/manage/mint-rewards/${id}/publish`),

  drawWinners: (id: string) =>
    apiClient.post<{ winners: SweepstakesWinner[] }>(`/manage/mint-rewards/${id}/draw`),

  resolve: (id: string, proofLinks?: string[]) =>
    apiClient.post<{ contest: SweepstakesContest }>(`/manage/mint-rewards/${id}/resolve`, { proofLinks }),

  getStats: (id: string) =>
    apiClient.get<{ participants: number; entries: number; eligibleOffers: number }>(`/manage/mint-rewards/${id}/stats`),
};
